/*
 * @Author: linyanxiang
 * @Date: 2025-11-28 15:28:54
 * @LastEditors: linyanxiang
 * @LastEditTime: 2026-10-19 16:37:05
 * @Description: 文件用途描述
 */
import {getAttrValue} from '@/utils/helper' 
export const CHANNEL_GROUP = {
    COMMON: 0,
    LIGHT: 1,
    SLIDE: 2,
    EQUIPMENT: 3,
    AWNING: 4,
    MAIN: 5,
    GEN: 6,
    MAIN_HEAD: 7
}

// 油位数量
export const OIL_COUNT = {
    NO: 0,
    GEN: 1,
    GEN_AUX: 2
}

// 判断发电机配置情况
export const HAVE_ALT_AEA = {
    NO_GEN: 0,
    IS_GEN: 1,
    IS_AGS_GEN: 2
}

export const tempUnitMap = {
    0: '℃',
    1: '℉'
}

// 需要加序号的设备列表
export const DEVICE_LIST = ['MPPT', 'DUT', 'Inverter Charger', 'L6', 'ALT', 'Combi', 'DMT']

export const AC_SOURCE = {
    MAIN: 0,
    GEN: 1
}

// 事件名称转化
export const EVENT_MAP = {
    // AC6,
    // ACU,
    // AIR,
    // App,
    // Battery,
    // DTU-BLE,
    // BM500,
    // BS,
    'Inverter Charger': 'Combi',
    'DC Module': 'CRS',
    // CX,
    // ALT,
    // Gas,
    // L6,
    'GY485': 'Level',
    // M10,
    // MTS,
    // P6,
    // PCU,
    // MPPT,
    'TPMS': 'Tire',
    'DCDC' : 'ALT'
    // Truma,
    // Xcm16
}

export const bmsModuleType = {
    0: 'N/A',
    1: 'BI',
    2: 'DM',
    3: 'DX',
    4: 'ACU',
    5: 'BI',
    6: 'ARCO',
    7: 'DM+ARCO'
}

 

const bmsFields = {
    key: 'Bms',
    legendFields: [{
        legend: 'SOC',
        field: 'bms_all_soc',
        color: '#009EDA',
        unit: '%'
    }, {
        legend: 'Voltage',
        field: 'bms_1_vol',
        color: '#00DA8F',
        unit: 'V'
    }, {
        legend: 'Current',
        field: 'bms_1_cur',
        color: '#76FF00',
        unit: 'A'
    }, {
        legend: 'Max Cell Temperature',
        field: 'bms_1_cell_tmp',
        color: '#FF00D8',
        getUnit: (system) => {
            const unit = Number(getAttrValue(system, '0.realMap.temp_unit.0.data.value', 0))
            return tempUnitMap[unit]
        }
    }, {
        legend: 'Min Cell Temperature',
        field: 'bms_1_cell_min_temp',
        color: '#0031FF',
        getUnit: (system) => {
            const unit = Number(getAttrValue(system, '0.realMap.temp_unit.0.data.value', 0))
            return tempUnitMap[unit]
        }
    }],
}

const invFields = {
    key: 'Inverter', 
    legendFields: [{
        legend: 'Load',
        field: 'inv_{{index}}_ac_output_power',
        color: '#009EDA',
        unit: 'W'
    }, {
        legend: 'Charging Current',
        field: 'inv_{{index}}_charge_cur',
        color: '#00DA8F',
        unit: 'A'
    }, {
        legend: 'Output Voltage',
        field: 'inv_{{index}}_ac_output_vol',
        color: '#76FF00',
        unit: 'V'
    }, {
        legend: 'Output Current',
        field: 'inv_{{index}}_ac_output_cur',
        color: '#FF00D8',
        unit: 'A'
    }, {
        legend: 'Input Voltage',
        field: 'inv_{{index}}_ac_input_vol',
        color: '#0031FF',
        unit: 'V'
    }
]}

const solarFields = {
    key: 'Solar',
    legendFields: [{
        legend: 'PV Voltage',
        field: 'mppt_{{index}}_pv_vol',
        color: '#009EDA',
        unit: 'V'
    }, {
        legend: 'Charging Current',
        field: 'mppt_{{index}}_out_cur',
        color: '#00DA8F',
        unit: 'A'
    }, {
        legend: 'Output Power',
        field: 'mppt_{{index}}_out_power',
        color: '#76FF00',
        unit: 'W'
    }]
}

const altFields = {
    key: 'Alt',
    legendFields: [{
        legend: 'ALT Voltage',
        field: 'dcdc_{{index}}_alt_vol',
        color: '#009EDA',
        unit: 'V'
    }, {
        legend: 'Charging Current',
        field: 'dcdc_{{index}}_out_cur',
        color: '#00DA8F',
        unit: 'A'
    }, {
        legend: 'Output Power',
        field:'dcdc_{{index}}_out_power',
        color: '#76FF00',
        unit: 'W'
    }]
}

const biFields = {
     key: 'Bi',
    legendFields: [{
        legend: '12V Voltage',
        field: 'dcdc_{{index}}_alt_vol',
        color: '#009EDA',
        unit: 'V'
    }, {
        legend: '48V Voltage',
        field: 'dcdc_{{index}}_out_vol',
        color: '#00DA8F',
        unit: 'V'
    }, {
        legend: '48V Current',
        field:'dcdc_{{index}}_out_cur',
        color: '#76FF00',
        unit: 'A'
    }, {
        legend: '48V Output Power',
        field:'dcdc_{{index}}_out_power',
        color: '#0031FF',
        unit: 'W'
    }]
}

export const deviceFields = [bmsFields, invFields, solarFields, altFields, biFields]

